import React from 'react';
import PropTypes from 'prop-types';
import { StyledMonth } from './style';

const Month = ({ date, className }) => (
  <StyledMonth className={className} format="MMMM" element="span">
    {date}
  </StyledMonth>
);

Month.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string
};

export default Month;
